import routes from "../../routes/routes";
import { TenantConfigService } from "../../types/tenantConfig";

/**
 * Where a use case's home-screen entry point leads.
 *
 * One definition for the whole home screen: the service card and the default
 * banner both read it, so the two tap targets a user sees for the same use case
 * can never drift apart. Note `keys` opens the location selection (the card's
 * long-standing entry), not `/key-handover/book`.
 */
export const SERVICE_ENTRY_ROUTE: Record<TenantConfigService, string> = {
  storage: routes.temStorageNewBooking,
  rental: routes.bookLocationEquipmentRentalPath,
  p2p: routes.bookLocationP2PPath,
  parcel: routes.bookParcelDeliveryPath,
  apartment: routes.roomRentalPath,
  venue: routes.venueReservationPath,
  hall: routes.hallReservationPath,
  keys: routes.keyHandoverLocationSelectionPath,
  sup: routes.bookLocationSUPPath,
  voucher: routes.voucherPath,
  moreToCome: routes.moreToComePath,
};
